//import * as actions from '../../actions/actionTypes';

const initialState = [];

export default function regionPlatformList(state = initialState, action) {
  switch (action.type) {
    case 'SET_REGION_PLATFORM':
      return action.payload;
    default:
      return state;
  }
}
